import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "TheHeaderNav header-nav",
  "aria-label": "Header menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderNavItem = _resolveComponent("TheHeaderNavItem")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MENU_HEADER, (menuItem) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: menuItem.slug
      }, [
        (_ctx.visibleMenuList.includes(menuItem.slug))
          ? (_openBlock(), _createBlock(_component_TheHeaderNavItem, {
              key: 0,
              name: menuItem.name,
              children: menuItem.children,
              path: menuItem.path,
              clickable: menuItem.clickable,
              "current-app": menuItem.currentApp
            }, null, 8, ["name", "children", "path", "clickable", "current-app"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}